// extracted by mini-css-extract-plugin
export var categoryIcon = "RtwNn";
export var categoryName = "ZX7BU";
export var compact = "C6Gc_";
export var contentContainer = "tTwzD";
export var medium = "PhdVg";
export var toggleFavoriteButton = "tlKle";